export class Engine {
  name: string = null;
  code: string = null;
  desc: string = null;
  id: string = null;
  powertrainId: string = null;
  status: number = null;
  hoursread: number = null;
  lastHoursread: number = null;
  prevLastHoursread: number = null;
  lastOrder: number = null;
  alias: number = null;
  startDate: string = null;

  getAlias() {
    return this.alias;
  }

  setAlias(alias: number) {
    this.alias = alias;
  }

  getStartDate() {
    return this.startDate;
  }

  setStartDate(d: string) {
    this.startDate = d;
  }

  getName() {
    return this.name;
  }

  getCode() {
    return this.code;
  }

  getDesc() {
    return this.desc;
  }

  getStatus() {
    return this.status;
  }

  getLastOrder() {
    return this.lastOrder;
  }

  getHoursread() {
    return this.hoursread;
  }

  getLastHoursread() {
    return this.lastHoursread;
  }

  getPrevLastHoursread() {
    return this.prevLastHoursread;
  }

  getPowertrainId() {
    return this.powertrainId;
  }

  setName(name: string) {
    this.name = name;
  }

  setCode(code: string) {
    this.code = code;
  }

  setDesc(desc: string) {
    this.desc = desc;
  }

  setId(id: string) {
    this.id = id;
  }

  setPowertrainId(id: string) {
    this.powertrainId = id;
  }

  setStatus(status: number) {
    this.status = status;
  }

  setLastOrder(hoursread: number) {
    this.lastOrder = hoursread;
  }

  setHoursread(hoursread: number) {
    this.hoursread = hoursread;
  }

  setLastHoursread(hoursread: number) {
    this.lastHoursread = hoursread;
  }

  setPrevLastHoursread(hoursread: number) {
    this.prevLastHoursread = hoursread;
  }

  reset() {
    this.setId(null);
    this.setName(null);
    this.setPowertrainId(null);
    this.setStatus(null);
    this.setCode(null);
    this.setDesc(null);
    this.setStartDate(null);
    this.setAlias(null);
  }
}
